import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import { IconArrowRight, IconUser } from "./icons";
import brandLogo from "./assets/d_logo-removebg-preview.png";
import { AuthUserContext } from "../Session";
import { getDashboardRouteForEmail } from "../../utils/dashboardRouting";

const navItems = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Why Partner", path: "/why-partner" },
  { label: "Partnership Model", path: "/partnership-model" },
  { label: "Divisions", path: "/divisions" },
  { label: "Leadership", path: "/leadership" },
  { label: "Insights", path: "/insights" },
  { label: "Contact", path: "/contact" },
];

const SESSION_WINDOW_MS = 48 * 60 * 60 * 1000;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const authUser = useContext(AuthUserContext);

  const isActive = (path) => location.pathname === path;
  const isSessionValid = () => {
    if (!authUser || typeof window === "undefined") {
      return false;
    }
    const raw = window.localStorage.getItem("lastLoginAt");
    const lastLoginAt = raw ? Number(raw) : NaN;
    return Number.isFinite(lastLoginAt) && Date.now() - lastLoginAt <= SESSION_WINDOW_MS;
  };
  const handleLoginClick = (event, closeMenu = false) => {
    if (isSessionValid()) {
      event.preventDefault();
      history.push(getDashboardRouteForEmail(authUser?.email));
    }
    if (closeMenu) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (typeof document === "undefined") {
      return undefined;
    }

    document.body.style.overflow = isMenuOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <header className={`premium-navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-inner">
        <Link to="/" className="logo" aria-label="Douglas & McCartney">
          <img src={brandLogo} alt="Douglas & McCartney" className="logo-image" decoding="async" />
        </Link>

        <ul className="nav-links hidden lg:flex">
          {navItems.map((item) => (
            <li key={item.path} className="nav-item">
              <Link
                to={item.path}
                className={`nav-link${isActive(item.path) ? " active" : ""}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="nav-actions">
          <Link
            to={ROUTES.SIGN_IN}
            className="login-btn hidden lg:inline-flex"
            onClick={handleLoginClick}
          >
            <IconUser className="h-4 w-4" />
            Log In
          </Link>
          <Link
            to={ROUTES.SIGN_UP}
            className="cta-btn hidden lg:inline-flex"
          >
            <span>Sign Up</span>
            <IconArrowRight className="h-3.5 w-3.5" />
          </Link>
          <button
            className={`mobile-menu-btn lg:hidden${isMenuOpen ? " active" : ""}`}
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
            type="button"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      <div className={`mobile-nav lg:hidden${isMenuOpen ? " active" : ""}`}>
        <ul className="mobile-nav-links">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className="mobile-nav-link"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <Link
          to={ROUTES.SIGN_IN}
          className="login-btn mobile-login-btn"
          onClick={(event) => handleLoginClick(event, true)}
        >
          <IconUser className="h-4 w-4" />
          Log In
        </Link>
        <Link
          to={ROUTES.SIGN_UP}
          className="mobile-cta"
          onClick={() => setIsMenuOpen(false)}
        >
          Sign Up
        </Link>
      </div>
    </header>
  );
};

export default Header;
